



































import { IClient } from "@/models/clients";
import { DataModules } from "@/store/modules/data";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ClientSupportPinView extends Vue {
  // Data

  public isGenerating = false;
  public isMasked = true;
  public supportPin = "";

  // Life-cycle methods

  public created() {
    this.supportPin = this.client.support_pin || "";
  }

  // Computed

  public get client() {
    return this.$store.state.user as IClient;
  }

  public get visiblePin() {
    return this.isMasked ? "•".repeat(6) : this.supportPin;
  }

  public get action() {
    if (this.isMasked) return this.$t("_action.show_pin");
    return this.$t("_action.copy_and_hide");
  }

  // Methods

  public togglePin($event) {
    $event.stopPropagation();
    if (!this.isMasked)
      this.$store.dispatch("ui/copyToClipboard", this.supportPin);
    this.isMasked = !this.isMasked;
  }

  public async generateSupportPin() {
    if (this.isGenerating) return;
    try {
      this.isGenerating = true;
      const supportPin = (
        await this.$store.dispatch(
          `data/${DataModules.CLIENTS}/generateSupportPin`,
          {
            clientId: this.client.id
          }
        )
      ).join("");

      await this.$store.dispatch(
        `data/${DataModules.CLIENTS}/updateSupportPin`,
        {
          clientId: this.client.id,
          supportPin
        }
      );

      this.$set(this, "supportPin", supportPin);
      this.$set(this, "isMasked", false);
    } finally {
      this.isGenerating = false;
    }
  }
}
